<template>
  <div class="home">
    home页面
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
  },
  created() {
  },
  methods: {
    goPage() {

    }
  }
}
</script>
